export default `
 About Copy
`.trim();



// WEBPACK FOOTER //
// ./src/fixtures/about.js